import { UserInfo } from 'hub-http/userInfo';
import { createContext, useContext } from 'react';

export type AuthState = Partial<UserInfo>;

const AuthContext = createContext<AuthState>({});

export const AuthProvider = AuthContext.Provider;

export function useAuth() {
  return useContext(AuthContext);
}

export function useIsUngated(gateName: string) {
  const { gates } = useAuth();
  return gates?.includes(gateName);
}
